import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import pushEvent, { EVENT_OPEN_BALLOON_PICKUPBUY, EVENT_CLOSE_BALLOON_PICKUPBUY } from 'pushEvent';

import { YAMap, MapPointBaloon } from '../YAMap';
import styles from './styles.pcss';

const cx = classNames.bind(styles);
export default class PointsMapView extends React.PureComponent {
  render() {
    const {
      points,
      pins,
      className,
      isMobile,
      openPickupBuy,
      goBasket,
      idForMap,
      classForMap,
      viewState,
      messageClass,
    } = this.props;
    return (
      <div>
        <div className={cx('component', className, isMobile ? 'mobile' : null)}>
          {points.length > 0 && (
            <YAMap
              points={points.filter((point) => point.latitude && point.longitude)}
              isMobile={isMobile}
              mapId={idForMap}
              className={classForMap}
              pins={pins}
              onBaloonOpen={() => {
                pushEvent(EVENT_OPEN_BALLOON_PICKUPBUY);
              }}
              onBaloonClose={() => {
                pushEvent(EVENT_CLOSE_BALLOON_PICKUPBUY);
              }}
              hasClusters
            >
              {(props) => (
                <MapPointBaloon {...props} viewState={viewState} onClick={openPickupBuy} />
              )}
            </YAMap>
          )}
        </div>
        {/* TODO: расхардкодить */}
        {isMobile && (
          <div className={cx('message', messageClass, isMobile ? 'mobile' : null)}>
            Если вы не нашли подходящий вам магазин,&nbsp;
            <span className={cx('action')} onClick={goBasket} role="button" tabIndex={0}>
              положите товар в корзину,
            </span>
            &nbsp;и мы доставим его с курьером
          </div>
        )}
      </div>
    );
  }
}

PointsMapView.propTypes = {
  points: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      address: PropTypes.string,
      opening: PropTypes.string,
      availableDate: PropTypes.string,
      subway: PropTypes.shape({
        header: PropTypes.string,
        color: PropTypes.string,
      }),
      partner: PropTypes.shape({
        slug: PropTypes.string,
        id: PropTypes.number,
      }),
      priceSubTitle: PropTypes.string,
      onlyCard: PropTypes.bool,
      onlyCardTitle: PropTypes.string,
    }),
  ),
  pins: PropTypes.object,
  className: PropTypes.string,
  messageClass: PropTypes.string,
  isMobile: PropTypes.bool,
  openPickupBuy: PropTypes.func,
  goBasket: PropTypes.func,
  idForMap: PropTypes.string,
  classForMap: PropTypes.string,
  viewState: PropTypes.string,
};
